import * as React from "react";
import {useEffect, useState} from "react";
import {LandingPagePayload} from "../contenful/types";
import './styles/PromotionArea.scss';
import {slideNext} from "../utils/SlideNext";


interface Props {
    landingpage: LandingPagePayload;
}


const PromotionArea: React.FC<Props> = ({landingpage}) => {
    const [mouseOn, setMouseOn] = useState(false)
    let time = 5000;
    if(landingpage.sliderPromotionArea && landingpage.promotionArea && landingpage.promotionArea.length > 4) {
        time = landingpage.sliderPromotionAreaTiming &&
        landingpage.sliderPromotionAreaTiming[0] ? parseInt(landingpage.sliderPromotionAreaTiming[0]) : 2000

    }
    useEffect(() => {
        const slideWrapper = document.getElementById('promoWrapper')
        if(!mouseOn) {
            const handleInterval = setInterval(() => {
                slideNext(slideWrapper)
            }, time);
            return () => clearInterval(handleInterval);
        }
    });
    const mouseEnter = () => {
        setMouseOn(true)
    }
    const mouseLeave = () => {
        setMouseOn(false)
    }
    const sliderPromo = landingpage.sliderPromotionArea &&
    landingpage.promotionArea&& landingpage.promotionArea.length > 4 ? "slider" : ''

    return (
        <div className={"promotionAreaContainer"}>
            {
                landingpage.promotionAreaTitle&& (<span className={"promotionAreaTitle"}>{landingpage.promotionAreaTitle}</span>)
            }
            {
                landingpage.promotionArea&& landingpage.promotionArea.length === 6
                    ? (
                        <div className={`promotionAreaSmall ${sliderPromo}`} id="promoWrapper"
                        onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}>
                            {
                                landingpage.promotionArea&& landingpage.promotionArea.map((image, index) => {
                                    if(image&& image.fields&& image.fields.file&& image.fields.file.url) {
                                        return (
                                            <div key={index} className={"imageContainer"}>
                                                {
                                                    image.fields&& image.fields.description&& (
                                                        <span className={"textLabel"}>{image.fields.description}</span>
                                                    )
                                                }
                                                <img alt={"promotion"} key={index} onClick={() => {}} src={image.fields.file.url} width={image.fields.file.details.image.width} height={image.fields.file.details.image.height}/>
                                                {
                                                    image.fields&& image.fields.title&& (
                                                        <span className={"imageTitle"}>{image.fields.title}</span>
                                                    )
                                                }
                                            </div>
                                        )
                                    } else {
                                        return null;
                                    }
                                })
                            }
                        </div>
                    )
                    : (
                        <div className={`promotionArea ${sliderPromo}`} id="promoWrapper"
                        onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}>
                            {
                                landingpage.promotionArea&& landingpage.promotionArea.map((image, index) => {
                                    if(image&& image.fields&& image.fields.file&& image.fields.file.url) {
                                        return (
                                                <div key={index} className={"imageContainer"}>
                                                    {
                                                        image.fields&& image.fields.description&& (
                                                            <span className={"textLabel"}>{image.fields.description}</span>
                                                        )
                                                    }
                                                    <img alt="promotion" key={index} onClick={() => {}} src={image.fields.file.url} width={image.fields.file.details.image.width} height={image.fields.file.details.image.height}/>
                                                    {
                                                        image.fields&& image.fields.title&& (
                                                            <span className={"imageTitle"}>{image.fields.title}</span>
                                                        )
                                                    }
                                                </div>
                                                )
                                    } else {
                                        return null;
                                    }
                                })
                            }
                        </div>
                    )
            }
        </div>
    )
}

export default PromotionArea;

